import React, { useState, useEffect } from 'react';
import Moment from 'moment';
import PropTypes from 'prop-types';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
  IconButton,
} from '@material-ui/core';
import AttachmentIcon from '@material-ui/icons/Attachment';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import { withStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';
import ConsultNoteEditModal from './ConsultNoteEditModal';
import ConsultNoteAttachmentModal from './ConsultNoteAttachmentModal';
import { getPatientConsultNotes } from '../services/api';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

function PatientChartConsultNotes(props) {
  const {
    patientId,
    classes: {
      loading,
      customSpacing
    },
  } = props

  const enqueueSnackbar = useSnackbar();
  const pageLimit = 10;


  const [isLoading, setIsLoading] = useState(false);
  const [consultNotes, setConsultNotes] = useState([]);
  const [inspectedConsultNote, setInspectedConsultNote] = useState(null);
  const [pageIndex, setPageIndex] = useState(0);
  const [attachment, setAttachment] = useState(null)

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        await getPatientAppointmentConsultNotes();
        // if(!patientId){
        //   return
        // }
        // const fetchedConsultNotes = await getPatientConsultNotes(patientId);
        // setConsultNotes(fetchedConsultNotes);
      } catch (err) {
        enqueueSnackbar("Unable to fetch patient's notes");
      }
      setIsLoading(false);
    })();
  }, [patientId, pageIndex])



  const getPatientAppointmentConsultNotes = async () => {
    const fetchedConsultNotes = await getPatientConsultNotes(patientId, pageLimit, pageIndex * 10);
    setConsultNotes(fetchedConsultNotes);
    setIsLoading(false);
  }

  const onPageBack = async () => {
    if (pageIndex === 0) {
      enqueueSnackbar('You are on the first page');
    }
    else {
      setPageIndex(pageIndex - 1)
    }
  };

  const onPageForward = async () => {
    setPageIndex(pageIndex + 1)
  };


  return isLoading ? (
    <div className={loading}>
      <CircularProgress />
    </div>
  ) : (
      <>
      <div style={{overflow:"scroll"}}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>From</TableCell>
              <TableCell>To</TableCell>
              <TableCell>Created At</TableCell>
              <TableCell>View Message</TableCell>
              <TableCell>Attachments</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {consultNotes.sort((c1, c2) => Moment(c1.createdAt).isAfter(c2.createdAt) ? -1 : 1).map(consultNote => (
              <TableRow key={consultNote.id}>
                <TableCell>{consultNote.fromProvider.name}</TableCell>
                <TableCell>{consultNote.toProvider.name}</TableCell>
                <TableCell>{Moment(consultNote.createdAt).format('YYYY-MM-DD h:mma')}</TableCell>
                <TableCell>
                  <IconButton
                    onClick={() => setInspectedConsultNote(consultNote)}
                  >
                    <RemoveRedEyeIcon />
                  </IconButton>
                </TableCell>
                <TableCell>
                  {
                    consultNote.isAttachment ?
                      <IconButton
                        title={consultNote.isAttachment ? "View Attachment" : null}
                      >
                        <AttachmentIcon onClick={() => setAttachment(consultNote)} />
                      </IconButton> : <span className={props.classes.customSpacing}>-</span>
                  }
                  {/* <IconButton
                    title={consultNote.isAttachment ? "View Attachment" : "No Attachment Found"}
                  >

                    {consultNote.isAttachment ?
                      <AttachmentIcon onClick={() => setAttachment(consultNote)} /> :
                      '-'}

                  </IconButton> */}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        </div>
        {inspectedConsultNote &&
          <ConsultNoteEditModal
            viewOnly
            open={!!inspectedConsultNote}
            note={{
              id: inspectedConsultNote.id,
              body: inspectedConsultNote.body,
              patientId: inspectedConsultNote.patient.id,
              patientName: inspectedConsultNote.patient.name,
              toProviderId: inspectedConsultNote.toProvider.id,
              toProviderName: inspectedConsultNote.toProvider.name,
              toProviderImageUrl: inspectedConsultNote.toProvider.imageUrl,
              fromProviderId: inspectedConsultNote.fromProvider.id,
              fromProviderName: inspectedConsultNote.fromProvider.name,
              fromProviderImageUrl: inspectedConsultNote.fromProvider.imageUrl,
              archivedById: inspectedConsultNote.archivedById,
              createdAt: inspectedConsultNote.createdAt,
            }}
            onClose={() => setInspectedConsultNote(null)}
          />
        }
        {attachment &&
          <ConsultNoteAttachmentModal
            viewOnly={true}
            open={!!attachment}
            note={{
              id: attachment.id,
              body: attachment.body,
              // patientId: attachment.patient.id,
              // patientName: attachment.patient.name,
              // toProviderId: attachment.toProvider.id,
              // toProviderName: attachment.toProvider.name,
              // toProviderImageUrl: attachment.toProvider.imageUrl,
              // fromProviderId: attachment.fromProvider.id,
              // fromProviderName: attachment.fromProvider.name,
              // fromProviderImageUrl: attachment.fromProvider.imageUrl,
              // archivedById: attachment.archivedById,
              createdAt: attachment.createdAt,
            }}
            onClose={() => setAttachment(null)}
          />
        }
        <div className={props.classes.pageTurners}>
          <IconButton disabled={pageIndex === 0}>
            <ArrowBackIosIcon
              style={{ opacity: pageIndex === 0 ? '0.5' : '1.0' }}
              color="primary"
              variant="contained"
              onClick={onPageBack}
            />
          </IconButton>
          <IconButton >
            <ArrowForwardIosIcon
              style={{ opacity: consultNotes.length < pageLimit ? '0.5' : '1.0' }}
              color="primary"
              variant="contained"
              onClick={onPageForward}
            />
          </IconButton>
        </div>
      </>
    );
}

PatientChartConsultNotes.propTypes = {
  patient: PropTypes.object,
};

const styles = () => ({
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  pageTurners: {
    width: '100%',
    marginTop: '5px',
    display: 'flex',
    justifyContent: 'space-between'
  },
  customSpacing: {
    marginLeft: '21px',
    display:'block'
  }
});

export default withStyles(styles)(PatientChartConsultNotes);
